import type { Game } from "../game"

export const isEndOfRound = ({ game }: { game: Game.Instance }): boolean => {
  return game.turnId === game.rounds[game.roundId].turns.length - 1
}
